import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useHopeWorkMasters } from '@/composables/format-edit/useHopeWorkMasters'
import {
  HOPE_SELECT_MAX,
  groupHopeAreas,
  hopeAreaLabel
} from '@/utils/format-edit/hopeWorkCondition'

type SelectOption = {
  value: string
  label: string
}

type OptionGroup = {
  igCd?: string
  jgCd?: string
  label: string
  options?: SelectOption[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HopeConditionFields',
  props: {
    formatData: null,
    bizreachIndustryGroups: { default: () => [] },
    bizreachJobCategoryGroups: { default: () => [] },
    hopeAreaDefaultCode: { default: '' }
  },
  emits: ["update-format-data"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update-format-data', payload: Record<string, unknown>): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { formatData: Record<string, unknown>, bizreachIndustryGroups: OptionGroup[], bizreachJobCategoryGroups: OptionGroup[], hopeAreaDefaultCode: string };





function emittedFormatField(key: string) {
  return computed({
    get: () => props.formatData[key],
    set: (value: unknown) => emit('update-format-data', { [key]: value })
  })
}

const hopeWorkAreas = emittedFormatField('hopeWorkAreas')
const hopeTurnTime = emittedFormatField('hopeTurnTime')
const hopeIndustryCds = emittedFormatField('hopeIndustryCds')
const hopeJobCategoryCds = emittedFormatField('hopeJobCategoryCds')

const hopeMasters = useHopeWorkMasters()
const mastersReady = computed(() => hopeMasters.status.value === 'ready')
const mastersPlaceholder = computed(() => {
  if (hopeMasters.status.value === 'error') {
    return '選択肢を読み込めませんでした。時間をおいて開き直してください'
  }
  return mastersReady.value ? '' : '読み込み中…'
})
const hopeAreaGroups = computed(() =>
  groupHopeAreas(hopeMasters.workAreas.value)
)
const hopeTurnTimeOptions = hopeMasters.turnTimes
const hopeSelectMax = HOPE_SELECT_MAX

// 注記は「現住所をそのまま初期値として使っている」状態のときだけ出す。
// ユーザーが選び直したら文言が実態と合わなくなるので消す
const showHopeAreaDefaultNote = computed(() => {
  const areas = props.formatData.hopeWorkAreas
  return (
    Boolean(props.hopeAreaDefaultCode) &&
    Array.isArray(areas) &&
    areas.length === 1 &&
    areas[0] === props.hopeAreaDefaultCode
  )
})

const hopeAreaDefaultLabel = computed(() =>
  hopeAreaLabel(hopeMasters.workAreas.value, props.hopeAreaDefaultCode)
)

return { __sfc: true,props, emit, emittedFormatField, hopeWorkAreas, hopeTurnTime, hopeIndustryCds, hopeJobCategoryCds, hopeMasters, mastersReady, mastersPlaceholder, hopeAreaGroups, hopeTurnTimeOptions, hopeSelectMax, showHopeAreaDefaultNote, hopeAreaDefaultLabel }
}

})